var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"sub_sec"},[_c('TermsWrap',{attrs:{"telecom":_vm.telecom,"termsIdx":_vm.termsIdx,"termsContents":_vm.termsContents},on:{"changeTelecom":_vm.changeTelecom,"changeTermsIdx":_vm.changeTermsIdx}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }